import { Login } from "modules/auth";

const LoginPage = () => {
  return <Login />;
};

export default LoginPage;
